export default __webpack_public_path__ + "static/media/chat-widget.2daf4f1a.svg";